module.exports = __webpack_public_path__ + "static/noPhotoMate@2x-8f9c283afed5812f6705edb471da0700.jpg";